export default "__VITE_ASSET__DQaNjFlZ__"